import { useEffect, useState } from "react";
import { Snackbar } from "../../components/Snackbar";
import {
  DEFAULT_SNACKBAR,
  ERROR_CREDENTIALS,
  ERROR_EMPTY_CREDENTIALS,
  SUCCESS_CREDENTIALS,
} from "../../utils/snackbar";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { useNavigate } from "react-router-dom";
import { useMoodleV2 } from "../../contexts/moodle";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { useConfig } from "../../contexts/config";
import LoginFormV2 from "../../components/LoginForm";
import { useTheme } from "../../contexts/ThemeContext";
import ForgotPasswordForm from "../../components/LoginForm/ForgotPasswordForm";

const Login = () => {
  const [snackbar, setSnackbar] = useState(DEFAULT_SNACKBAR);
  const [credentials, setCredentials] = useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();
  const moodlev2 = useMoodleV2();
  const { config } = useConfig();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, [moodlev2]);

  useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "imagen2",
        "bg-auto",
        "bigDesktop:bg-cover"
      );
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");
        navigate("/listcourses");
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);


 
  return (
    <div className="w-full h-screen  flex items-center justify-center relative overflow-hidden">
      {/* Main Container */}
      <div className="z-10 w-full  mx-auto px-4 laptop:px-8">
        <div className="grid grid-cols-1 laptop:grid-cols-12 gap-8 laptop:gap-12 items-center min-h-[90vh]">
          {/* Left Column - Login Form */}
          <div className="laptop:col-span-6 flex justify-center">
            <div className="relative w-full max-w-[39rem]">
              {/* Glow Effect */}
              <div
                className={`absolute inset-0 bg-gradient-to-r from-[${
                  theme?.colors.tertiary_dark || "#44BCF9"
                }] to-[${
                  theme?.colors.text_login_light || "#E63289"
                }] rounded-3xl blur-xl opacity-20`}
              ></div>

              {/* Form Container */}
              <div
                className={`relative bg-gradient-to-br from-[${
                  theme?.colors.tertiary_dark || "#8C7FC8"
                }] to-[${
                  theme?.colors.text_login_light || "#7B6BC6"
                }] p-1 rounded-3xl`}
              >
                <div
                  style={{
                    backgroundColor: theme?.colors.backgroundColorBodyLogin
                      ? theme?.colors.backgroundColorBodyLogin
                      : "#000000",
                  }}
                  className=" rounded-[1.4rem] p-2 tablet:p-8 shadow-2xl"
                >
                  {/* Header with Logo */}
                  <div className="text-center mb-8">
                    <div className="text-center mb-8 w-full h-[12dvh] p-3">
                      <img
                        src={
                          config?.config?.theme?.theme_logo_dark ||
                          "/logo-aprender-steam-2025-dark.png"
                        }
                        alt="Logo"
                        className="h-full w-full object-contain"
                      />
                    </div>
                    {/* <h2 className="text-2xl font-bold text-gray-900">
                      ¡Bienvenido!
                    </h2>
                    <p className="text-gray-600 mt-2">
                      Inicia sesión para continuar
                    </p> */}
                  </div>

                  {/* Login Form */}
                  {!showForgotPassword && <LoginFormV2
                    handleChange={handleChange}
                    credentials={credentials}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    setShowForgotPassword={setShowForgotPassword}
                  />}
                  {/* Forgot Password Form */}
                  {
                    showForgotPassword && 
                    <ForgotPasswordForm onBackToLogin={() => setShowForgotPassword(false)} />
                  }
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Quote and Video (Desktop only) */}
          <div className="hidden laptop:flex laptop:col-span-7 flex-col justify-center space-y-8 h-full"></div>
        </div>
      </div>
      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </div>
  );
};

export default Login;
